<div #container class="echart-container" [class.echart-loading]="loading"></div>
